export default __webpack_public_path__ + "static/media/fetured-item-4.a466b835.png";